<template>
  <div class="c-domain-setup-form">
    <el-form
        ref="form"
        :model="domainSetupForm"
        label-position="top"
        label-width="120px"
        @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="Domain">
            <el-select
                v-model="currentDomainID"
                class="w-full gray"
                placeholder="Choose a domain"
                default-first-option
                filterable>
              <el-option
                  v-for="domain in allDomains"
                  :key="domain.id"
                  :label="domain.url"
                  :value="domain.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="1" class="target-settings mb-4">
          <el-form-item label="Show on specific pages">
            <el-switch v-model="targetAllPages"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :offset="12">
          <el-form-item v-if="targetAllPages">
            <div class="flex flex-col items-start gap-y-2">
              <div class="w-full flex gap-x-2">
                <el-input
                    ref="saveTagInput"
                    v-model="inputValue"
                    class="grow gray"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"/>
                <el-button
                    class="button-new-url"
                    size="medium"
                    @click="handleInputConfirm">
                  Add
                </el-button>

              </div>

              <el-tag
                  v-for="(page, index) in alphabeticallySortedPages"
                  :key="index"
                  :disable-transitions="false"
                  closable
                  @close="handleClose(page)">
                /{{ page }}
              </el-tag>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'DomainSetupForm',
  data() {
    return {
      enableUpdate: false,
      inputValue: '',
      targetAllPages: false,
      domainSetupForm: {
        domain: '',
        domainID: '',
        domain_pages: [],
      },
    }
  },
  computed: {
    allDomains() {
      return this.$store.state.domain.domains
    },
    campaign() {
      return this.$store.getters['campaign/targetCampaign']
    },
    currentDomainID: {
      get() {
        return this.domainSetupForm.domainID
      },
      set(domainID) {
        const domainObj = this.allDomains.find(domain => domain.id === domainID)

        if (domainObj) {
          this.domainSetupForm.domain = domainObj.url
          this.domainSetupForm.domainID = domainObj.id
        } else {
          console.error('Selected domain ID does not exist in allDomains')
        }
      },
    },
    alphabeticallySortedPages() {
      return this.domainSetupForm.domain_pages
          ? this.domainSetupForm.domain_pages.slice().sort((a, b) => a - b)
          : ''
    },
  },
  watch: {
    'campaign.domain'(newVal) {
      if (this.domainSetupForm.domain !== newVal) {
        this.domainSetupForm.domain = newVal
      }
    },
    'campaign.domainID'(newVal) {
      if (this.domainSetupForm.domainID !== newVal) {
        this.domainSetupForm.domainID = newVal
      }
    },
    'campaign.domain_pages'(newVal) {
      if (JSON.stringify(this.domainSetupForm.domain_pages) !== JSON.stringify(newVal)) {
        this.domainSetupForm.domain_pages = newVal
      }
    },
    domainSetupForm: {
      handler() {
        if (this.enableUpdate) {
          this.$emit('update', this.domainSetupForm)
        }
      },
      deep: true,
      immediate: false,
    },
  },
  created() {
    this.setFormValues()
    this.$nextTick(() => {
      this.enableUpdate = true
    })
  },
  methods: {
    setFormValues() {
      const newValue = JSON.parse(JSON.stringify(this.campaign))
      this.domainSetupForm.domain = newValue.domain
      this.domainSetupForm.domainID = newValue.domainID
      this.domainSetupForm.domain_pages = newValue.domain_pages
    },
    handleClose(tag) {
      this.domainSetupForm.domain_pages.splice(
          this.domainSetupForm.domain_pages.indexOf(tag),
          1,
      )
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        this.domainSetupForm.domain_pages.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
  },
}
</script>

<style lang="scss">
.c-domain-setup-form {

  .el-form-item {
    width: 100%;
  }

  .el-switch__label span {
    margin-bottom: 10px;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1em;
  }

  .target-settings {
    .el-tag {
      display: block;
      margin: 5px 0;
    }

    .el-button {
      padding: 11px 20px;
    }
  }
}
</style>
